$(function () {
  //from https://bost.ocks.org/mike/shuffle/
  function shuffle(array) {
    var m = array.length, t, i;

    // While there remain elements to shuffle…
    while (m) {
      // Pick a remaining element…
      i = Math.floor(Math.random() * m--);

      // And swap it with the current element.
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }

    return array;
  }

  let $input = $('#input')
  let $shuffle = $('#shuffle')
  let $output = $('#output')

  let sDemo = "a\t1\t2\t3\t4\t5\t6\t7\t8\t9\t10\n"
  $input.val(sDemo)
  //quick and dirty do everything in memory

  $shuffle.click(() => {

    $output.html("")
    $input.val().split('\n').forEach((row) => {
      let aRow = row.split('\t')
      let sHead = aRow.shift()
      let aRnd = shuffle(aRow)
      aRnd.unshift(sHead)
      $output.append(aRnd.join("\t") + "\n")
    })

  });


});

